import { ActionsBar as BaseActionsBar } from '@work4all/components/lib/dataDisplay/actions-bar/ActionsBar';

import { withAutoDisable } from '../../mask-overlay/utils/with-auto-disable';

export const ActionsBar = withAutoDisable(BaseActionsBar);
